import './App.css';
import {useEffect, useState} from "react";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import Login from "./pages/Auth/Login";
import Pages from "./pages/Pages";
import ProkuraturaPages from "./pages/prokuratura/ProkuraturaPages";
import {Navigate, Route, Routes} from "react-router-dom";
import SignUp from "./pages/Auth/SignUp";
import {Logout} from "./Components/Actions/Actions";

const normalizeRole = (role) => (role || '').trim().toLowerCase();

function App() {

  // expiret_at serverda Unix soniyalarda (Login.js uni o'zgartirmasdan saqlaydi)
  const expiret = Number(localStorage.getItem('reestr-expiret'));
  if(expiret && expiret * 1000 <= Date.now()){
    localStorage.removeItem('reestr-expiret');
    localStorage.removeItem('reestr-token');
    localStorage.removeItem('reestr-role');
  }
  const token = localStorage.getItem('reestr-token');

  // localStorage dagi rol faqat taxmin: haqiqiy rolni server aytadi (eski sessiya yoki eski build qoldirgan
  // qiymat noto'g'ri sahifa ochib yubormasligi uchun). Server javob bermasa, saqlangan qiymat ishlatiladi.
  const [role, setRole] = useState(() => normalizeRole(localStorage.getItem('reestr-role')));
  const [roleChecked, setRoleChecked] = useState(false);

  useEffect(() => {
    if (!token) return undefined;
    const controller = new AbortController();
    let cancelled = false;
    // server javob bermasa "..." abadiy qolmasin: 5 soniyadan keyin saqlangan rolga qaytamiz
    const timer = setTimeout(() => controller.abort(), 5000);
    fetch(process.env.REACT_APP_API_ENDPOINT + '/app/whoami', {
      headers: {Authorization: `Bearer ${token}`},
      signal: controller.signal,
    })
        .then((res) => {
          if (res.status === 401) {
            Logout();
            return null;
          }
          return res.ok ? res.json() : null;
        })
        .then((data) => {
          if (data && typeof data.role === 'string') {
            localStorage.setItem('reestr-role', data.role);
            setRole(normalizeRole(data.role));
          }
        })
        .catch(() => {})
        .finally(() => {
          clearTimeout(timer);
          if (!cancelled) setRoleChecked(true);
        });
    return () => {
      cancelled = true;
      clearTimeout(timer);
      controller.abort();
    };
  }, [token]);

  if (token && !roleChecked) {
    return <div className="text-center py-5 text-muted" role="status">...</div>;
  }

  const isProsecutor = role === 'prokuror';
  return (
      <Routes>
        {!token ? (
            <>
              <Route path="/login" element={<ErrorBoundary><Login /></ErrorBoundary>} />
              <Route path="/register" element={<ErrorBoundary><SignUp /></ErrorBoundary>} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
        ) : (
            <>
              <Route path="/*" element={isProsecutor ? <ProkuraturaPages /> : <Pages />} />
            </>
        )}
      </Routes>
  );
}

export default App;
